import clsx from 'clsx';
import { Activity, FC, ReactNode } from 'react';

export const FilterName: FC<{ icon: ReactNode; label: string; showNotificationBadge?: boolean }> = ({
  icon,
  label,
  showNotificationBadge,
}) => (
  <div className="relative flex items-center justify-between gap-4">
    <span className="flex items-center gap-4">
      {icon}
      <span className={clsx('c-fs-body1', 'font-extrabold')}>{label}</span>
    </span>
    <Activity mode={showNotificationBadge ? 'visible' : 'hidden'}>
      <span className="h-2 w-2 rounded-full bg-for-pri-acc" data-testid={`${label}-filter-notification`} />
    </Activity>
  </div>
);
